import type { z } from 'zod';
import {
  RefrigerationUnit,
  RefrigerationUnitComponent,
  RefrigerationUnitSafety,
  RefrigerationUnitSafetyThreshold,
  RefrigerationUnitTechnical,
} from '../../schemas';

export class DuplicateRefrigerationUnitNameError extends Error {
  readonly field = 'name' as const;
  constructor(name: string) {
    super(`Esiste già un impianto chiamato "${name}"`);
    this.name = 'DuplicateRefrigerationUnitNameError';
  }
}

export class RefrigerationUnitFieldError extends Error {
  readonly field: 'name' | 'location' | 'toxicGasType' | 'impiantoType';
  constructor(field: 'name' | 'location' | 'toxicGasType' | 'impiantoType', message: string) {
    super(message);
    this.name = 'RefrigerationUnitFieldError';
    this.field = field;
  }
}

export type RefrigerationUnitComponentInput = Omit<
  z.input<typeof RefrigerationUnitComponent>,
  'id'
> & {
  id?: string;
};

export type RefrigerationUnitSafetyThresholdInput = Omit<
  z.input<typeof RefrigerationUnitSafetyThreshold>,
  'id'
> & {
  id?: string;
};

type RefrigerationUnitSafetySchemaInput = NonNullable<z.input<typeof RefrigerationUnitSafety>>;
type RefrigerationUnitDetectorsSchemaInput = NonNullable<
  RefrigerationUnitSafetySchemaInput['detectors']
>;
export type RefrigerationUnitSafetyInput = Omit<RefrigerationUnitSafetySchemaInput, 'detectors'> & {
  detectors?: Omit<RefrigerationUnitDetectorsSchemaInput, 'thresholds'> & {
    thresholds?: RefrigerationUnitSafetyThresholdInput[];
  };
};

type RefrigerationUnitTechnicalSchemaInput = NonNullable<
  z.input<typeof RefrigerationUnitTechnical>
>;
export type RefrigerationUnitTechnicalInput = Omit<
  RefrigerationUnitTechnicalSchemaInput,
  'components' | 'safety'
> & {
  components?: RefrigerationUnitComponentInput[];
  safety?: RefrigerationUnitSafetyInput;
};

type RefrigerationUnitSchemaInput = z.input<typeof RefrigerationUnit>;
export type RefrigerationUnitInput = Partial<
  Omit<
    RefrigerationUnitSchemaInput,
    'id' | 'createdAt' | 'updatedAt' | 'refrigerationUnitId' | 'name' | 'technical'
  >
> & {
  id?: RefrigerationUnitSchemaInput['id'];
  refrigerationUnitId: RefrigerationUnitSchemaInput['refrigerationUnitId'];
  name: RefrigerationUnitSchemaInput['name'];
  technical?: RefrigerationUnitTechnicalInput;
};

export type RefrigerationUnitUpdateInput = Partial<RefrigerationUnitInput> & {
  id: string;
};
